module.exports = __webpack_public_path__ + "static/media/minus.d5428943.svg";